import React from 'react'
import OverviewDetailItem from './OverviewDetailItem'

const OverviewDetailItems = ({ supplier: { foundingYear, employeeCount, annualRevenue, duns } }) => {
  if (foundingYear || employeeCount || annualRevenue || duns) {
    return (
      <div className='grid-x' id='supplier-detail-items'>
        <div className='medium-3 small-6 cell border-right small-border-bottom'>
          <OverviewDetailItem
            title='Founded'
            value={foundingYear}
          />
        </div>
        <div className='medium-3 small-6 cell border-right small-border-bottom'>
          <OverviewDetailItem
            title='DUNS Number'
            value={duns}
          />
        </div>
        <div className='medium-3 small-6 cell border-right'>
          <OverviewDetailItem
            title='Company Size'
            value={employeeCount}
          />
        </div>
        <div className='medium-3 small-6 cell'>
          <OverviewDetailItem
            title='Annual Revenue'
            value={annualRevenue || ''}
          />
        </div>
      </div>
    )
  } else {
    return (<></>)
  }
}

export default OverviewDetailItems
